export default __webpack_public_path__ + "static/media/group-629@2x.d80b0b73.png";